import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ComparatorBuilder, ElderTableComponent, ViewProviders } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { ConstraintConf } from '../constraint-conf'
import { ConstraintInput } from '../constraintInput'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ConstraintInputComponent } from '../constraint-input/constraint-input.component'

import { MatIcon } from '@angular/material/icon'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-constraints-table',
  templateUrl: './constraint-table.component.html',
  styleUrls: ['./constraint-table.component.scss'],
  viewProviders: [ViewProviders.ParentControlContainer],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    ConstraintInputComponent,
    ElderTranslatePipe,
    AsyncPipe,
  ],
})
export class ConstraintTableComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  readonly constraints$: BehaviorSubject<ConstraintConf[]> = new BehaviorSubject<ConstraintConf[]>(
    []
  )

  @Input()
  public tripleStateBoolean: boolean

  @Input()
  public name: string

  @Input()
  public set constraints(constraints: ConstraintConf[]) {
    this.constraints$.next(constraints?.sort(ComparatorBuilder.fieldSort('spec.description')))
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onConstraintConfUpdated(constraint: ConstraintInput, constraints: ConstraintConf[]): void {
    const constraintToUpdate = constraints.find((c) => c.constraintSpecId === constraint?.spec?.id)
    if (constraintToUpdate) {
      constraintToUpdate.values = constraint.values
    }
  }
}
